import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Button } from "react-bootstrap";
import Cookie from "js-cookie";
import { connect } from "react-redux";

import * as Constants from "../../../../constants/Constants";
import AppContext from "../../../../context/appcontext";
import CommonActionsModal from "./CommonActionsModal";
import {
  httpPostSendAccountPayableEmail,
  httpPostReturnVendorToMerchant,
  httpPostSubmitToDbmOrMerchOps,
  httpPostDVNAuditNotes,
  httpPostSaveVendorStatusByProfileId,
  httpGetVendorStatusDetails,
  httpPostDeleteVendorProfileByprofileId,
} from "../../../../service/httpClient";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import * as rolePermConsts from "../../../../constants/RolePermissionConstants";

import { updateServiceData } from "../../../../redux/serviceSlice";
import {
  updateCommonInfo,
  resetCommonSliceData,
} from "../../../../redux/commonSlice";

class TabHeader extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      clicked: "",
      openActionModal: false,
      actionType: "",
      comments: "",
      actionBtnDisabled: false,
      actionError: "",
      note: "",
      noteCategory: "",
      dataRequestType: "",
      dataRequestTypeComment: "",
      dataRequestTypeErr: false,
      noteError: false,
      inactiveCategory: "",
      vendorDeleteOption: "",
    };
  }

  componentDidMount() {
    if (this.props.title === Constants.DOCUMENT_CENTER) {
      this.setState({ clicked: Constants.OB_HEAD_DOC_CENTER_TXT });
    } else if (this.props.title === Constants.OB_HEAD_NOTES_TXT) {
      this.setState({ clicked: Constants.OB_HEAD_NOTES_TXT });
    } else if (this.props.title === Constants.OB_HEAD_VEND_MASTER_TXT) {
      this.setState({ clicked: Constants.OB_HEAD_VEND_MASTER_TXT });
    } else {
      this.setState({ clicked: Constants.OB_HEAD_ONBOARDING_TXT });
    }
  }

  navigate = (id, url) => {
    const {
      match: { params },
    } = this.props;
    if (localStorage.getItem("vid")) {
      url = `${url}/${localStorage.getItem("vid")}`;
    }
    switch (id) {
      case Constants.OB_HEAD_ONBOARDING_TXT:
        this.setState({ clicked: Constants.OB_HEAD_ONBOARDING_TXT });
        this.props.history.push(url);
        break;
      case Constants.OB_HEAD_NOTIFICATION_TXT:
        this.setState({ clicked: Constants.OB_HEAD_NOTIFICATION_TXT });
        this.props.history.push(url);
        break;
      case Constants.OB_HEAD_DOC_CENTER_TXT:
        this.setState({ clicked: Constants.OB_HEAD_DOC_CENTER_TXT });
        this.props.history.push(url);
        break;
      case Constants.OB_HEAD_NOTES_TXT:
        this.setState({ clicked: Constants.OB_HEAD_NOTES_TXT });
        this.props.history.push(url);
        break;
      case Constants.OB_HEAD_VEND_MASTER_TXT:
        this.setState({ clicked: Constants.OB_HEAD_VEND_MASTER_TXT });
        this.props.history.push(url);
        break;
      case Constants.VENDOR_PROFILE:
        this.setState({ clicked: Constants.VENDOR_PROFILE });
        this.props.history.push(url);
        break;
      default:
        break;
    }
  };

  onToggleClassHandler = (value) => {
    return value === this.state.clicked
      ? ["onboardHeaderClicked"]
      : ["onboardHeader"];
  };

  openCommonActionsModal = () => {
    this.setState({ openActionModal: true });
  };

  closeCommonActionsModal = () => {
    this.setState({ openActionModal: false }, () => this.resetModalStates());
  };

  resetModalStates = () => {
    this.setState({
      actionType: "",
      comments: "",
      actionBtnDisabled: false,
      note: "",
      noteCategory: "",
      dataRequestType: "",
      noteError: false,
      inactiveCategory: "",
      vendorDeleteOption: "",
    });
  };

  handleChange = (e) => {
    const { name = "", value = "" } = e.target || {};
    if (e.target.type === "checkbox") {
      this.setState({
        actionType: value === this.state.actionType ? "" : value,
        comments: "",
        note: "",
        noteCategory: "",
        inactiveCategory: "",
        vendorDeleteOption: "",
        dataRequestType: "",
        dataRequestTypeComment: ""
      });
    } else {
      if (name === "comments") {
        const limit =
          this.state.actionType === Constants.ACTION_OPTIONS_DVN_AUDIT_NOTES ||
            this.state.actionType ===
            Constants.ACTION_OPTIONS_INACTIVE_STATUS_VENDOR
            ? 401
            : 1001;
        const charLeft = limit - value?.length;

        if (charLeft > 0) {
          this.setState({ comments: value });
        }
      }
      if (name === "deleteOption") {
        this.setState({ vendorDeleteOption: value });
        if (value === "no") {
          this.setState({ comments: "" });
        }
      }
      if (name === "noteCategory") {
        const flag = value === "";
        this.setState({ noteCategory: value, noteError: flag });
      }
      if (name === "dataRequestType") {
        const flag = value === "";
        this.setState({ dataRequestType: value, noteError: flag });
      }
      if (name === "inactiveCategory") {
        const flag = value === "";
        this.setState({ inactiveCategory: value, noteError: flag });
      }
      if (name === "note") {
        this.setState({ note: value });
      }
      if (name === "dataRequestTypeComment") {
        this.setState({ dataRequestTypeComment: value });
      }
    }

    this.setState({ actionError: "", noteError: false, dataRequestTypeErr: false, dataRequestTypeErrComment: false });
  };

  onClickHandler = () => {
    const {
      actionType = "",
      comments = "",
      note = "",
      noteCategory = "",
      dataRequestType = "",
      dataRequestTypeComment = "",
      inactiveCategory = "",
    } = this.state;

    this.setState({ actionBtnDisabled: true });

    if (
      actionType === Constants.ACTION_OPTIONS_REQUEST_VENDOR ||
      actionType === Constants.ACTION_OPTIONS_REQUEST_MERCHANT ||
      actionType === Constants.ACTION_OPTIONS_DVN_AUDIT_NOTES ||
      actionType === Constants.ACTION_OPTIONS_REQUEST_CONSIGNMENT_ADMIN ||
      actionType === Constants.MP_REQUEST_MORE_DATA_ID
    ) {
      let email = Cookie.get("email") ? Cookie.get("email").toLowerCase() : "";
      let updatedBy = Cookie.get("userName") ? Cookie.get("userName") : "";

      let moreDetailFrom =
        actionType === Constants.ACTION_OPTIONS_REQUEST_VENDOR
          ? Constants.VENDOR
          : actionType === Constants.ACTION_OPTIONS_REQUEST_CONSIGNMENT_ADMIN
            ? Constants.CONSIGNMENT_ADMIN
            : actionType === Constants.MP_REQUEST_MORE_DATA_ID ?
              Constants.MP_REQUEST_MORE_DATA_ID
              : Constants.MERCHANT;
      if (comments !== "" || dataRequestTypeComment != "") {
        this.setState({ actionBtnDisabled: true });

        let apiHandler = httpPostSendAccountPayableEmail;
        let payload = {
          vendorProfileId: this.props.vendorProfileId,
          updatedBy: updatedBy,
          updatedByEmail: email,
          comments: dataRequestTypeComment != "" ? dataRequestTypeComment + "|" + dataRequestType : comments,
        };

        if (actionType !== Constants.ACTION_OPTIONS_DVN_AUDIT_NOTES) {
          payload = {
            ...payload,
            moreDetailFrom: moreDetailFrom,
          };
        }

        if (actionType === Constants.ACTION_OPTIONS_DVN_AUDIT_NOTES) {
          apiHandler = httpPostDVNAuditNotes;
          payload = {
            ...payload,
            moreDetailFrom: "DVNAudit",
          };
        }

        apiHandler &&
          apiHandler(payload)
            .then((res) => {
              this.setState({ actionBtnDisabled: false }, () => {
                this.closeCommonActionsModal();
                this.props.getTopThreeNotes();
                this.props.getAllNotes();
              });
            })
            .catch((err) => {
              const errorMessage =
                err.response && err.response.data && err.response.data.message
                  ? err.response.data.message
                  : Constants.MSG_UNABLE_TO_SEND_EMAIL;

              this.setState({
                actionError: errorMessage,
                actionBtnDisabled: false,
              });
              console.log(errorMessage);
            });
      }
    } else if (actionType === Constants.ACTION_OPTIONS_RETURN_TO_MERCHANT) {
      const dataToSubmit = {
        note: note,
        noteCategory: noteCategory,
        vendorProfileId: this.props.vendorProfileId,
        email: Cookie.get("email"),
        updatedByFullName: Cookie.get("userName"),
        duns: this.props.duns,
      };

      httpPostReturnVendorToMerchant(dataToSubmit)
        .then((res) => {
          this.closeCommonActionsModal();
          this.props.fetchVendorData(this.props.vendorProfileId);
        })
        .catch((err) => {
          const errorMessage =
            err.response && err.response.data && err.response.data.message;

          this.setState({
            actionError: errorMessage,
            actionBtnDisabled: false,
          });
          console.log(errorMessage);
        });
    } else if (actionType === Constants.ACTION_OPTIONS_SUBMIT_TO_MERCHANT) {
      let vendorDataToSubmit = {
        vendorProfileId: this.props.vendorProfileId,
        submittedBy: Cookie.get("email"),
        lastActivity: "submittedToMerchOps",
        lastUpdatedBy: Cookie.get("email"),
      };

      httpPostSubmitToDbmOrMerchOps(vendorDataToSubmit)
        .then((res) => {
          this.setState({ actionBtnDisabled: false }, () => {
            this.closeCommonActionsModal();
          });
        })
        .catch((err) => {
          const errorMessage =
            err.response && err.response.data && err.response.data.message;

          this.setState({
            actionError: errorMessage,
            actionBtnDisabled: false,
          });
          console.log(errorMessage);
        });
    } else if (
      actionType === Constants.ACTION_OPTIONS_REMOVE_VENDOR_INACTIVE_STATUS ||
      actionType === Constants.ACTION_OPTIONS_INACTIVE_STATUS_VENDOR
    ) {
      const {
        vendorStatus = [],
        vendorProfileId,
        extractVendorStatus,
      } = this.props;

      if (vendorStatus.length > 0) {
        const vendorHoldStatus = vendorStatus.find(
          (item) =>
            item.statusName === Constants.HOLD_ID &&
            item.vendorStatus?.statusId === 18
        );
        let statusCompleted = true; // Mark inactive/hold status as approved
        if (
          vendorHoldStatus?.vendorStatus?.lastStatusUpdatedValue ===
            Constants.APPROVED &&
          vendorHoldStatus?.vendorStatus?.statusCompleted
        ) {
          statusCompleted = false; // Mark inactive/hold as false if already approved
        }

        const userEmail = Cookie.get("email")
          ? Cookie.get("email").toLowerCase()
          : "";
        const updatedByFullName = Cookie.get("userName")
          ? Cookie.get("userName")
          : "";

        const data = {
          ...vendorHoldStatus,
          vendorStatus: {
            ...vendorHoldStatus?.vendorStatus,
            subStatus: statusCompleted ? inactiveCategory : null,
            statusCompleted,
            lastStatusUpdatedValue: statusCompleted
              ? Constants.APPROVED
              : Constants.NOT_STARTED,
            lastStatusUpdatedBy: userEmail,
          },
          comments,
          userEmail,
          updatedByFullName,
        };

        httpPostSaveVendorStatusByProfileId(data)
          .then((res) => {
            if (res && res.status === 200) {
              return httpGetVendorStatusDetails(vendorProfileId);
            } else {
              throw new Error("Something went wrong, try after sometime.");
            }
          })
          .then((res) => {
            const vendorHoldStatus = res.data?.find(
              (item) =>
                item.statusName === Constants.HOLD_ID &&
                item.vendorStatus?.statusId === 18
            );
            const { mutatedVendorStatus } = extractVendorStatus(
              vendorHoldStatus.onboardingStatus ===
                Constants.VENDOR_SUBMISSION ||
                vendorHoldStatus.onboardingStatus ===
                  Constants.VENDOR_REGISTRATION ||
                data.onboardingStatus === Constants.VENDOR_SUBMISSION ||
                data.onboardingStatus === Constants.VENDOR_REGISTRATION
                ? Constants.PENDING
                : Constants.APPROVED,
              res.data
            );

            //update vendorStatus in service data
            this.props.updateServiceData({
              vendorStatus: res.data,
            });

            //update vendorstatus in common slice
            this.props.updateCommonInfo({
              boardingStatuses: mutatedVendorStatus,
            });

            this.closeCommonActionsModal();
            this.setState({
              actionError: "",
              actionBtnDisabled: false,
            });
          })
          .catch((error) => {
            this.setState({
              actionError: error.message,
              actionBtnDisabled: false,
            });
          });
      } else {
        this.setState({
          actionError: "Invalid vendor status",
          actionBtnDisabled: false,
        });
      }
    } else if (actionType === Constants.ACTION_OPTIONS_DELETE_VENDOR) {
      let deletePayload = {
        deleteReason: comments,
        deletedBy: Cookie.get("email"),
      };
      httpPostDeleteVendorProfileByprofileId(
        this.props.vendorProfileId,
        deletePayload
      )
        .then((res) => {
          this.setState({ actionBtnDisabled: false }, () => {
            this.closeCommonActionsModal();
            this.props.resetCommonSliceData();
            localStorage.removeItem("vid");
            this.props.updateCommonInfo({
              vendorHasDeleted: true,
            });
          });
        })
        .catch((err) => {
          const errorMessage =
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : Constants.MSG_UNABLE_TO_DELETE_VENDOR;

          this.setState({
            actionError: errorMessage,
            actionBtnDisabled: false,
          });
        });
    }
  };

  handleValidateDataReqType = () => {
    if(this.state.dataRequestType === "") {
      this.setState({ dataRequestTypeErr: !this.state.dataRequestTypeErr });
    }
  }

  handleValidate = () => {    
    if (this.state.noteCategory === "") {
      this.setState({ noteError: !this.state.noteError });
    }
  };

  render() {
    const actionBtnFlag =
      this.context.roles.roleName === Constants.EXTERNAL_VENDOR_GENERIC ||
      this.context.roles.roleName === Constants.EXTERNAL_GENERIC_ADMIN
        ? getUserRolePermission(
            rolePermConsts.VENDORPLATFORM_VENDORONBOARDING_ACTION,
            rolePermConsts.VMP_ACTION_BUTTON
          ) === rolePermConsts.EDIT &&
          this.props.onboardingStatus !== Constants.VENDOR_REGISTRATION
        : getUserRolePermission(
            rolePermConsts.VENDORPLATFORM_VENDORONBOARDING_ACTION,
            rolePermConsts.VMP_ACTION_BUTTON
          ) === rolePermConsts.EDIT;
    return (
      <Fragment>
        {this.state.openActionModal && (
          <CommonActionsModal
            show={this.state.openActionModal}
            closeCommonActionsModal={this.closeCommonActionsModal}
            actionType={this.state.actionType}
            handleChange={this.handleChange}
            comments={this.state.comments}
            onClickHandler={this.onClickHandler}
            actionBtnDisabled={this.state.actionBtnDisabled}
            actionError={this.state.actionError}
            onboardingStatus={this.props.onboardingStatus}
            note={this.state.note}
            noteCategory={this.state.noteCategory}
            dataRequestType={this.state.dataRequestType}
            dataRequestTypeComment={this.state.dataRequestTypeComment}
            dataRequestTypeErr={this.state.dataRequestTypeErr}
            inactiveCategory={this.state.inactiveCategory}
            noteError={this.state.noteError}
            handleValidate={this.handleValidate}
            vendorStatus={this.props.vendorStatus}
            vendorProfileDetails={this.props.vendorProfileDetails}
            vendorDeleteOption={this.state.vendorDeleteOption}
            handleValidateDataReqType={this.handleValidateDataReqType}
          />
        )}
        <div className="col-md-12">
          <div className="alignItemCenter" style={{ display: "flex" }}>
            <div
              className={this.onToggleClassHandler(
                Constants.OB_HEAD_ONBOARDING_TXT
              ).join(" ")}
              id={Constants.OB_HEAD_ONBOARDING_TXT}
              onClick={(event) => {
                this.props.setFetchingTrue && this.props.setFetchingTrue();
                this.navigate(
                  Constants.OB_HEAD_ONBOARDING_TXT,
                  "/boarding/vendor/company"
                );
              }}
            >
              {Constants.OB_HEAD_ONBOARDING_TXT}
            </div>
            <div
              className={this.onToggleClassHandler(
                Constants.OB_HEAD_DOC_CENTER_TXT
              ).join(" ")}
              id={Constants.OB_HEAD_DOC_CENTER_TXT}
              onClick={(event) => {
                this.props.setFetchingTrue && this.props.setFetchingTrue();
                this.navigate(
                  Constants.OB_HEAD_DOC_CENTER_TXT,
                  "/boarding/vendor/documentCenter"
                );
              }}
            >
              {Constants.OB_HEAD_DOC_CENTER_TXT}
            </div>
            <div
              className={this.onToggleClassHandler(
                Constants.OB_HEAD_NOTES_TXT
              ).join(" ")}
              id={Constants.OB_HEAD_NOTES_TXT}
              onClick={(event) => {
                this.props.getTopThreeNotes && this.props.getTopThreeNotes();
                this.context.roles.roleName !==
                  Constants.EXTERNAL_VENDOR_GENERIC &&
                this.context.roles.roleName !== Constants.EXTERNAL_GENERIC_ADMIN
                  ? this.navigate(
                      Constants.OB_HEAD_NOTES_TXT,
                      "/boarding/vendor/note"
                    )
                  : null;
              }}
              style={{
                cursor:
                  this.context.roles.roleName !==
                    Constants.EXTERNAL_VENDOR_GENERIC &&
                  this.context.roles.roleName !==
                    Constants.EXTERNAL_GENERIC_ADMIN
                    ? "pointer"
                    : "default",
              }}
            >
              {Constants.OB_HEAD_NOTES_TXT}
            </div>
            {actionBtnFlag && (
              <div
                style={{
                  cursor:
                    this.context.roles.roleName !==
                      Constants.EXTERNAL_VENDOR_GENERIC ||
                    this.context.roles.roleName !==
                      Constants.EXTERNAL_GENERIC_ADMIN
                      ? "pointer"
                      : "default",
                  paddingLeft: "3%",
                  borderBottom: "1px solid #626369",
                  marginBottom: "5px",
                  marginTop: "5px",
                }}
              >
                <Button
                  className="button-primary-md"
                  onClick={() => this.openCommonActionsModal()}
                  disabled={this.props.vendorProfileId === ""}
                >
                  {Constants.BUTTON_ACTIONS}
                </Button>
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateCommonInfo: (data) => dispatch(updateCommonInfo(data)),
    updateServiceData: (data) => dispatch(updateServiceData(data)),
    resetCommonSliceData: () => dispatch(resetCommonSliceData()),
  };
};

export default withRouter(connect(null, mapDispatchToProps)(TabHeader));
